module.exports = __webpack_public_path__ + "static/Push Technologies-5d6376ca57f1c18595f55cc8fdd3ac39.jpg";